import React from "react";
import { languages } from "../../../constants/languages";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import WidthMenu from "./WidthMenu";

export default class EditPouleSpot extends React.Component {
  render() {
    return (
      <div>
        {this.props.elementType === "poules" && (
          <FormControl
            size="small"
            variant="outlined"
            style={{ marginRight: 5 }}
          >
            <Select
              style={{ height: 30 }}
              value={this.props.showType}
              onChange={this.props.handleChange}
              inputProps={{
                name: this.props.showTypeDiaKey,
                id: this.props.showTypeDiaKey,
              }}
            >
              <MenuItem value="0">
                {languages.present.standingsAndSchedule}
              </MenuItem>
              <MenuItem value="1">{languages.present.onlyStandings}</MenuItem>
              <MenuItem value="2">{languages.present.onlySchedule}</MenuItem>
            </Select>
          </FormControl>
        )}
        <WidthMenu
          value={this.props.width}
          handleWidthChange={this.props.handleChange}
          inputProps={{
            name: this.props.widthDiaKey,
            id: this.props.widthDiaKey,
          }}
          onlyFullWidth={this.props.onlyFullWidth}
        />
      </div>
    );
  }
}
